module.exports = __webpack_public_path__ + "static/img/banner3.839bee5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/banner3.jpg
// module id = S6Ab
// module chunks = 1